import {
  MediaItem,
  MediaListParams,
  MediaListResponse,
  MediaResponse,
  DeleteMediaResponse,
  UploadSoundRequest,
  CopySoundsResult,
} from '../types/sound-management-types';
import { SoundManagementApi } from './sound-management-api';

/**
 * Sound Management Repository
 * Provides a clean interface for sound management operations
 */
export class SoundManagementRepository {
  constructor(private readonly api: SoundManagementApi) {}

  /**
   * Get sounds list with filtering
   */
  async getSounds(params: MediaListParams): Promise<MediaListResponse> {
    return this.api.getMediaList(params);
  }

  /**
   * Get a single sound by ID
   */
  async getSoundById(mediaId: number): Promise<MediaResponse> {
    return this.api.getMediaById(mediaId);
  }

  /**
   * Upload a new sound file
   */
  async uploadSound(request: UploadSoundRequest): Promise<MediaItem> {
    const response = await this.api.uploadMedia(
      request.file,
      request.applicationType,
      request.mediaType,
      request.languageCode,
      request.keyName
    );

    if (!response.isSuccess || !response.media) {
      throw new Error(response.errorMessage || 'Failed to upload sound');
    }

    return response.media;
  }

  /**
   * Delete a sound
   */
  async deleteSound(mediaId: number): Promise<DeleteMediaResponse> {
    return this.api.deleteMedia(mediaId);
  }

  /**
   * Copy all sound files from baseLanguageCode to newLanguageCode
   */
  async copySounds(
    newLanguageCode: string,
    baseLanguageCode: string
  ): Promise<CopySoundsResult> {
    return this.api.copySounds(newLanguageCode, baseLanguageCode);
  }
}
